<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center mb-5"><img src="img/logo.png" style="width: 80%;"></div>
          <!--div class="text-muted text-center mt-2 mb-3">
              Sign in
          </div-->
          <base-alert type="danger" class="mt-3" v-if="message !== ''">
           {{message}} 
          </base-alert>
          <form name="login" role="form" @submit.prevent="handleLogin(!v$.$invalid)" novalidate>
            <base-input
              formClasses="input-group-alternative mb-3"
              placeholder="Email"
              addon-left-icon="ni ni-email-83"
              v-model="v$.user.email.$model"
              :valid="isValid(v$.user.email)"
              focused
              required
            >
            </base-input>
            <base-input
              formClasses="input-group-alternative mb-3"
              placeholder="Password"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="v$.user.password.$model"
              :valid="isValid(v$.user.password)"
              required
            >
            </base-input>
            <div class="text-center">
              <base-button nativeType="submit" type="primary" class="my-4" :disabled="loading">Sign in</base-button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
            <router-link to="/forgot" class="text-light"
            ><small>Forgot password?</small></router-link
          >
        </div>
        <div class="col-6 text-right">
          <router-link to="/register" class="text-light"><small>Create account</small></router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AUTH_REQUEST } from "actions/auth";
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

export default {
  name: "login",
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      loading: false,
      isSubmitted: false,
      message: ""
    };
  },
  validations() {
    return {
        user: {
            email: {required, email},
            password: {required}
        } 
    } 
  },
  computed: {
      isAuthenticated() {
          return this.$store.getters.isAuthenticated;
      }
  },
  created() {
      if (this.isAuthenticated) {
          this.$router.push('/');
      }
  },
  methods: {
      isValid(item){
        if (!this.isSubmitted){
          return null;
        } 

        return !item.$invalid;
      }, 
      handleLogin(isValid) {
          this.isSubmitted = true;
          this.message = '';
          
          if (!isValid){
              return;
          } 

          this.loading = true;
          this.$store.dispatch(AUTH_REQUEST, this.user).then(
              () => {
                  this.$router.push('/');
              }, 
              error => {
                  this.loading = false;
                  this.message = (error.response && error.response.data && error.response.data.message);
              } 
          )
      } 
  }
};
</script>
<style>
/*html, body, #app, .auth-layout {
  height: 100%;
} */   
</style>
